var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavCheckAndConfirm',{attrs:{"text":_vm.assetsDescription,"backTo":_vm.backTo}},[void 0],2)
}
var staticRenderFns = []

export { render, staticRenderFns }